import { flattenSubOptions } from '#/modules/imsMgmt/settings/mtrStruct/helper/structFilterModel';
import { resolveMultiFilterLabels } from '#/modules/commonComponents/table/columnFilterUtils';

export function buildFilterStatusFieldsFromColumns(columns, ctx = {}) {
  const fields = [];
  const seen = new Set();

  columns.forEach((column) => {
    const meta = column.meta;
    const statusKey = meta?.filterStatusKey;

    if (!statusKey || seen.has(statusKey)) {
      return;
    }

    seen.add(statusKey);

    const field = {
      key: statusKey,
      label: meta.filterStatusLabel
        ?? (typeof column.header === 'string' ? column.header : statusKey),
    };

    if (meta.facet === 'tree' && ctx.structModel) {
      const options = meta.treeRole === 'main'
        ? ctx.structModel.mains
        : flattenSubOptions(ctx.structModel);

      field.resolveDisplay = (values) => resolveMultiFilterLabels(values, options);
    } else if (meta.resolveFilterDisplay) {
      field.resolveDisplay = (values) => meta.resolveFilterDisplay(values, ctx);
    }

    fields.push(field);
  });

  return fields;
}
